export default "__VITE_PUBLIC_ASSET__278965ad__"